module.exports = __webpack_public_path__ + "img/RFID工业打印机.8ebf86af.jpg";